// =====================================================
// 📁 POSCreditNoteProductGrid.tsx
// =====================================================

import { useMemo } from 'react';

import { useCreditNoteSaleLookup } from '../../../../../hooks/sale/useCreditNoteSaleLookup';

import POSCreditNoteProductCard from './POSCreditNoteProductCard';

interface Props {
  query?: string;
}

const POSCreditNoteProductGrid: React.FC<Props> = ({ query = '' }) => {
  // =====================================================
  // 🔹 Hooks
  // =====================================================
  const { selectedSaleDetail } = useCreditNoteSaleLookup();

  // =====================================================
  // 🔹 Products
  // =====================================================
  const products = selectedSaleDetail?.products || [];

  // =====================================================
  // 🔹 Filtered Products
  // =====================================================
  const filteredProducts = useMemo(() => {
    const normalizedQuery = query.trim().toLowerCase();

    if (!normalizedQuery) {
      return products;
    }

    return products.filter((product) =>
      product.productName?.toLowerCase().includes(normalizedQuery)
    );
  }, [products, query]);

  // =====================================================
  // 🎨 Empty
  // =====================================================
  if (!filteredProducts.length) {
    return (
      <div
        className="
          flex
          min-h-[220px]
          items-center
          justify-center

          rounded-2xl
          border
          border-dashed
          border-stroke

          bg-white

          text-center

          dark:border-strokedark
          dark:bg-boxdark
        "
      >
        <div>
          <p
            className="
              text-sm
              font-medium
              text-black

              dark:text-white
            "
          >
            No se encontraron productos
          </p>

          <p
            className="
              mt-1
              text-xs
              text-body
            "
          >
            Intenta cambiar el término de búsqueda.
          </p>
        </div>
      </div>
    );
  }

  // =====================================================
  // 🎨 Render
  // =====================================================
  return (
    <div
      className="
      grid
      grid-cols-1
      gap-4

      sm:grid-cols-2
      md:grid-cols-3
      xl:grid-cols-4
      2xl:grid-cols-5
    "
    >
      {filteredProducts.map((product) => (
        <POSCreditNoteProductCard key={product.productId} product={product} />
      ))}
    </div>
  );
};

export default POSCreditNoteProductGrid;
